import React from 'react';
import { Award, Medal, Trophy, Gem, Star } from 'lucide-react';

const BADGE_STYLES = {
  basic:    { label: 'Basic',    Icon: Star,   className: 'bg-slate-500/20 text-slate-300 border-slate-400/40' },
  bronze:   { label: 'Bronze',   Icon: Medal,  className: 'bg-orange-800/25 text-orange-300 border-orange-700/40' },
  gold:     { label: 'Gold',     Icon: Trophy, className: 'bg-yellow-500/20 text-yellow-300 border-yellow-500/50' },
  platinum: { label: 'Platinum', Icon: Award,  className: 'bg-slate-200/15 text-slate-100 border-slate-300/40' },
  diamond:  { label: 'Diamond',  Icon: Gem,    className: 'bg-cyan-500/20 text-cyan-300 border-cyan-400/50' },
};

// Small pill that displays a manually-assigned gamification badge on a user
// profile. Silent (renders nothing) when the user has no badge.
export default function UserBadge({ badge, size = 'md', testId = 'user-badge' }) {
  if (!badge) return null;
  const meta = BADGE_STYLES[badge];
  if (!meta) return null;
  const { Icon, label, className } = meta;
  const sizes = size === 'sm'
    ? 'text-[10px] px-2 py-0.5 gap-1'
    : 'text-xs px-2.5 py-1 gap-1.5';
  const iconSize = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border font-medium ${sizes} ${className}`}
      title={`${label} badge`}
    >
      <Icon className={iconSize} />
      <span>{label}</span>
    </span>
  );
}
